module.exports = __webpack_public_path__ + "static/media/astronomy_03.1f3844b1.jpg";